import { useAtom } from '@xstate/store/react';

import {
	addNotification,
	appendTextPreview,
	clearTextPreview,
	closeHer,
	herState,
	type HerNotification,
	type HerTask,
	openHer,
	removeNotification,
	setAnimating,
	setExpanded,
	toggleHer,
} from '../state/HerState';

export const useHerStore = (): {
	// State
	isHerActive: boolean;
	isExpanded: boolean;
	isAnimating: boolean;
	contentId: string | null;
	contentType: string;
	cloudID: string;
	textPreview: string;
	tasks: Record<string, HerTask>;
	notifications: Record<string, HerNotification>;
	// Actions
	toggleHer: (contentId?: string, cloudID?: string, contentType?: string) => void;
	openHer: (contentId?: string, cloudID?: string, contentType?: string) => void;
	closeHer: () => void;
	setExpanded: (expanded: boolean) => void;
	setAnimating: (animating: boolean) => void;
	appendTextPreview: (text: string) => void;
	clearTextPreview: () => void;
	addNotification: (notification: HerNotification) => void;
	removeNotification: (id: string) => void;
} => {
	const state = useAtom(herState);

	return {
		// State
		isHerActive: state.isHerActive,
		isExpanded: state.isExpanded,
		isAnimating: state.isAnimating,
		contentId: state.contentId,
		contentType: state.contentType,
		cloudID: state.cloudID,
		textPreview: state.textPreview,
		tasks: state.tasks,
		notifications: state.notifications,

		// Actions
		toggleHer,
		openHer,
		closeHer,
		setExpanded,
		setAnimating,
		appendTextPreview,
		clearTextPreview,
		addNotification,
		removeNotification,
	};
};
